// Put your application javascript here

var currentStep = 0;

$.fn.ProductBrick = function(params){
	this.each(function() {
		var _this = {};
		_this.$this = $(this);
		_this.productId = _this.$this.data('id');
		_this.productHandle = _this.$this.data('handle');

		_this.$selectedVariantDom = _this.$this.find('.color-label');
		_this.$selectedVariantImg = _this.$this.find('.product-img img');

		_this.$this.on('click', '.product-brick-color', function(){
			var $this = $(this);
			var variantId = $this.data('variantid');
			var title = $this.data('title');
			var img = $this.data('img');
			console.log(img);
			$this.siblings().removeClass('active');
			$this.addClass('active');
			_this.$selectedVariantDom.html(title);
			_this.$selectedVariantImg.attr('src', img);
		});

	});
	return this;
};

(function($){
	var $navbar = $('.navbar');
	var navbarHeight = $navbar.height();
	var jsArrayVar = '';
	var dotsData = [];
	$(document).ready(function(){

		if ( $('.tpl-index').length ) {
			jsArrayVar = $('.section__feature').data('array');
			dotsData = window.dotData[jsArrayVar];
		}

		//if ( window.outerWidth > 768) {
			$('body').on('touchmove', updateNavBar);
			$(window).on('scroll', updateNavBar);
			updateNavBar();
		//}

		$('.button-scroll-down').on('click',function(){
			document.documentElement.scrollTo({
		    top: $('.vioivfit-section').position().top-28,
		    behavior: "smooth"
		  });
		});

		initMagnify();
		initFeatureSlide();
		initProductBlock();
		initMobNav();
		initLang();
		initFeatureTabs();
		initImageSlider();
		initFeatureSlides();
		setupAccordion();
		setupToggle();

		themeEditorEvents();
	});

	function themeEditorEvents(){
		document.addEventListener("shopify:section:load", function(){
			initImageSlider();
		});

		document.addEventListener("shopify:section:unload", function(){
			$('.image-slider').flickity('destroy');
		});
	}

	function setupToggle(){
		var $this = $('.toggle-cta');
		var target = $this.data('target');
		var toggleClass = $this.data('tclass');
		var isHideOnClick = $this.data('hide-on-click');
		var defTxt = $this.data('def-txt');
		var altTxt = $this.data('alt-txt');
		$this.on('click', function(){
			if ( $this.hasClass('expanded') ) {
				$this.text(defTxt);
			} else {
				$this.text(altTxt);
			}
			$this.toggleClass('expanded');
			$(target).toggleClass(toggleClass);
			if ( isHideOnClick ){
				$this.addClass('hidden');
			}
		});
	}

	function initImageSlider(){
		$('.image-slider').each(function(){
			var $thisSlider = $(this),
				isShowDots = $(this).data('show-dots') || false,
				isShowArrows = $(this).data('show-arrows') || false,
				isLoop = $(this).data('loop') || false,
				interval = $(this).data('interval') || 4000
			;
			$thisSlider.flickity({
				// options
				cellAlign: 'center',
				contain: true,
				pageDots: isShowDots,
				prevNextButtons: isShowArrows,
				autoPlay: interval,
				wrapAround: isLoop,
				cellSelector: '.slider-slide'
			});
		});


	}

	function initFeatureTabs(){
		$('.feature-slider').flickity({
			// options
			cellAlign: 'left',
			contain: true,
			pageDots: false,
			prevNextButtons: false,
			autoPlay: 5000,
			cellSelector: '.feature-slide'
		}).on( 'change.flickity', function( event, index ) {
			var img = $('.feature-tab').eq(index).data('solid');
			//updateMagImg( img );
			$('.feature-tab').eq(index).click();
		});

		$('.feature-slider-mobile').flickity({
			// options
			cellAlign: 'left',
			contain: true,
			pageDots: false,
			prevNextButtons: false,
			autoPlay: 5000,
			cellSelector: '.feature-slide'
		})

		$('.feature-tab')
			.on('mouseenter', function(){
				console.log('mouseenter');
				$('.feature-slider').flickity('pausePlayer');
			})
			.on('mouseout', function(){
				console.log('mouseout');
				$('.feature-slider').flickity('unpausePlayer');
			});
		$('.mag-img').magnify();
		$('.tooltip-anchor').appendTo('.feature-slider');

		// handle window resize len image positioning
		$(window).resize(function(){
			var $featureCanvas = $('.feature-canvas');
			console.log($featureCanvas.width()+ " : "+$featureCanvas.height());
			$featureCanvas.siblings('.magnify-lens').css({
				'background-size': $featureCanvas.width()+"px "+$featureCanvas.height()+"px"
			});
		});
	}

	function initFeatureSlides(){
		$('.product-spec-slides').flickity({
			// options
			cellAlign: 'left',
			wrapAround: true,
			contain: true
		}).on( 'change.flickity', function( event, index ) {
			$('.product-spec-spot').removeClass('active');
			$('.product-spec-absolute[data-dot="'+(index+1)+'"]').find('.product-spec-spot').addClass('active');
			showSpot( index, .4, dotsData[index] );
		});
	}

	function initLang(){
		$('.lang-switch').on('click', '.navbar-item', function(e){
			e.preventDefault();
			var $nav = $(this),
				locale = $nav.data('locale');
			if( typeof LangShopSDK !== 'undefined' ) {
				LangShopSDK.switchLanguage(locale);
			}
			return false;
		});
	}

	function initMobNav() {
		var $burgers = getAll('.navbar-burger');

		if ($burgers.length > 0) {
			$burgers.forEach(function ($el) {
				if (!$el.dataset.target) {
					return;
				}

				$el.addEventListener('click', function () {
					var target = $el.dataset.target;
					var $target = document.getElementById(target);
					$el.classList.toggle('is-active');
					$target.classList.toggle('is-active');
				});
			});
		}

		$('.navbar-end a').on('click', function(e){
			// dismiss mobile menu upon click
			$('.navbar-burger').removeClass('is-active');
			$('#navbarMenuHeroB').removeClass('is-active');
		});
	}

	function initProductBlock(){
		$('.product-block').ProductBrick();
	}

	function initFeatureSlide() {
		$('.feature-tab').on('click', function(e){
			e.preventDefault();
			$('.feature-tab').removeClass('active');
			var $this = $(this);
			var imgSolid = $this.data('solid');

			$this.addClass('active');
			updateMagImg(imgSolid);

			$('.feature-slider').flickity('select', $this.index());
			return false;
		});
	}
	function updateMagImg(img){
		$('.magnify-lens').css('background-image', 'url(' + img + ')');
	}

	function getAll(selector) {
		var parent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : document;

		return Array.prototype.slice.call(parent.querySelectorAll(selector), 0);
	}

	function updateNavBar() {
		if ( window.pageYOffset > navbarHeight ) {
			$navbar.toggleClass('sticky', true);
			// document.getElementById('oiviofit-logo').setAttribute('viewBox','0 0 185.563 116');
		} else {
			$navbar.toggleClass('sticky', false);
			// document.getElementById('oiviofit-logo').setAttribute('viewBox','0 0 185.563 146');
		}
	}

	function initMagnify(){
		$('.section__feature').each(function(){
			var $featureSpots = $('.feature-spots');
			var ico1 = $featureSpots.data('icon');
			var ico2 = $featureSpots.data('icon-active');
			if ( typeof dotsData === 'undefined' ) return false;

			for(var i=1; i <= dotsData.length; i++){
				// positioning spot base on pos.left / pos.top
				$featureSpots.append(
					'<div data-dot="'+i+'" class="product-spec-absolute product-spec-absolute-'+i+'">'+
					'<div class="product-spec-spot product-spec-spot-'+i+'" '+
						'data-step="'+i+'" '+
						'style="left:'+dotsData[i-1].pos.left*100+'%;top:'+dotsData[i-1].pos.top*100+'%;">'+
						'<img class="ico-normal" src="'+ico1+'" />'+
						'<img class="ico-active" src="'+ico2+'" />'+
					'</div>'+
					'</div>');
			}

			$('.product-spec-spot').on('click', function(){
				if( screen.width < 768 ) return false;
				currentStep = $(this).data('step')-1;
				showSpot( currentStep, .4, dotsData[currentStep] );
			});
			setTimeout(function(){
				showSpot( 0, 0, dotsData[currentStep] );
				currentStep = 0;
				$(window).trigger('resize');
				$('.feature-tooltips, .feature-tooltips article:first').removeClass('is-hidden');
				$('.tooltip-anchor').css({
					left:dotsData[currentStep].pos.tt_x*100+"%",
					top:dotsData[currentStep].pos.tt_y*100+"%"
				});
			},1000);

			$('.spot').on('click', function(e){
				e.preventDefault();
				var $this = $(this);
				var idx = $this.data('dot') - 1;
				showSpot( idx, 0, dotsData[idx] );
				return false;
			});
			$(window).resize(function(){
				showSpot( currentStep, 0, dotsData[currentStep] );
			});
		});
	}

	function showSpot(step, speed, dotData) {
		var
			imgW = $('.feature-slider').width(),
			imgH = $('.feature-slider').height();

		// positioning the lens
		// base on .pos.pct_x / .pos.pct_y
		TweenMax.to('.magnify-lens', speed, {
			'background-position':dotData.pos.pct_x*-1*imgW+'px '+ dotData.pos.pct_y*-1*imgH+'px',
			'background-size':$('.feature-slider').width()+'px '+ $('.feature-slider').height()+'px',
			'left': dotData.pos.pct_x*100+'%',
			'top': dotData.pos.pct_y*100+'%'
		});
		$('.magnify-lens').css({
			'width': imgW / 7,
			'height': imgW / 7,
			'display': 'block'
		});

		// positioning tooltop base on pos.tt_x / pos.tt_y
		$('.tooltip-anchor').css({
			left:dotsData[step].pos.tt_x*100+"%",
			top:dotsData[step].pos.tt_y*100+"%"
		});
		$('.feature-tooltips').css({
			width: parseInt( dotsData[step].width ) + "px"
		});
		$('.feature-tooltips article').addClass('is-hidden');
		$('.feature-tooltips article[data-dot="'+(step+1)+'"]').removeClass('is-hidden');

		$('.product-spec-spot').removeClass('active');
		$('.product-spec-absolute[data-dot="'+(step+1)+'"]').find('.product-spec-spot').addClass('active');
		$specSpotList = $('.product-spec-spot-list');
		$specSpotList.find('.spot').removeClass('active');
		$specSpotList.find('.spot[data-dot="'+(step+1)+'"]').addClass('active');
	}

	function setupAccordion(){
		$('[data-accordion-toggle]').on('click', function(){
			var $accordion = $(this).closest('[data-accordion]'),
				$accordionItem = $(this).closest('[data-accordion-item]'),
				$accordionContent = $accordionItem.find('[data-accordion-content]');

			if( $accordionItem.hasClass('in') ) {
			$accordionContent.slideUp('fast');
			setTimeout(function(){
				$accordionItem.removeClass('in');
			}, 200);
			} else {
			if( $accordion.find('[data-accordion-item].in').length ) {
				$accordion.find('[data-accordion-content]').slideUp('fast');
				$accordion.find('[data-accordion-item]').removeClass('in');
				setTimeout(function(){
				$accordionContent.slideDown('fast');
				setTimeout(function(){
					$accordionItem.addClass('in');
				}, 200);
				}, 200);
			} else {
				$accordionContent.slideDown('fast');
				setTimeout(function(){
				$accordionItem.addClass('in');
				}, 200);
			}
			}
		});
	}
  

$(document).ready( function() {
    if(window.location.pathname == '/' ) {
        $(".hero-footer-ctas.is-hidden-desktop.center").show();
        } else {
        $(".hero-footer-ctas.is-hidden-desktop.center").hide();
        }
    });

})(jQuery);

function smoothScrollingTo(target){
  $('html,body').animate({scrollTop:$(target).offset().top - 250}, 500);
}
$('a[href^=\\#]').on('click', function(event){     
    event.preventDefault();
    smoothScrollingTo(this.hash);
});
$(document).ready(function(){
  smoothScrollingTo(location.hash);
});